const enterKeyCode = 13;
export const onKeyDown = (e, onChange) => {
  if (e.keyCode === enterKeyCode || e.which === enterKeyCode) {
    onChange();
  }
};
